import { Component, OnInit, NgZone, Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { UtilService } from 'src/app/services/util.service';
import { Events } from 'src/app/services/events.service';
import { ActivatedRoute } from '@angular/router';
import { RestaurantService } from 'src/app/services/restaurant.service';
import { DBService } from 'src/app/services/db.service';
import { of } from 'rxjs';
import { Router } from '@angular/router';


@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {
  //*** Const Block  ***/
  public readonly LOGIN_VIEW: string = "login"
  public readonly RESET_VIEW: string = "reset"
  public readonly REGISTER_VIEW: string = "register"
  // ***************** //

  mail: string = ""
  mailCheck: string = ""

  password: string = ""

  restaurantName: string = ""

  @Input() currentView: string

  // *** Bei Neuregistrierung muss man den Datenschutzhinweisen zustimmen ***
  privacyAccepted: boolean = false

  constructor(private authService: AuthService, public util: UtilService, private ngZone: NgZone, private router: Router, private route: ActivatedRoute,
    private events: Events, private restaurantService: RestaurantService, private db: DBService) {
    this.currentView = this.route.snapshot.paramMap.get('view');
  }

  ngOnInit() {
  }

  passwordReset() {
    if (this.allFieldsAreFilled(this.mail)) {
      this.authService.passwordReset(this.mail.trim().toLowerCase()).then((res => {
        this.util.presentToast("Du hast nun eine E-Mail zum Zurücksetzen des Passworts erhalten.", 3000, "toast-success")
        this.openView(this.LOGIN_VIEW)
      }),
        (err: any) => {
          this.util.presentToast("Ein Fehler ist aufgetreten. Leider konnten wir dein Passwort nicht zurücksetzen.", 3000, "toast-warning")
          console.error("Fehler beim Passwort zurücksetzen", err)
        })
    }
  }

  /**
   * Registriert sich, ein erstes Restaurant wird dann erstellt und der neu registrierte User als Besitzer eingetragen.
   */
  register() {
    let amount: number = 0
    let myRef = this
    if (myRef.allFieldsAreFilled(myRef.mail, myRef.mailCheck, myRef.password, myRef.restaurantName)) {
      if (!myRef.privacyAccepted) {
        myRef.util.presentToast("Bitte lese und stimme unseren Datenschutzbestimmungen zu, um dich zu registrieren.", 3000, "toast-warning")
        return
      }

      if (myRef.mail.trim().toLowerCase() !== myRef.mailCheck.trim().toLowerCase()) {
        myRef.util.presentToast("Bitte kontrolliere deine E-Mail Adresse, da deine Eingaben nicht übereinstimmen.", 5000, "toast-warning")
        return
      }

      myRef.events.subscribe('registered', (userID) => {
        myRef.events.unsubscribe('registered')
        if (amount++ < 1) {
          myRef.restaurantService.createNewRestaurant(userID, myRef.restaurantName)

          myRef.events.subscribe('restaurant-created', (restaurantID) => {
            myRef.events.unsubscribe('restaurant-created')
            if (restaurantID) {
              myRef.db.selectRestaurant(restaurantID)
              myRef.ngZone.run(() => myRef.router.navigate(['/owner-home']))
            }
          })
        }
      })

      myRef.authService.signup(myRef.mail.trim().toLowerCase(), myRef.password)
    }
  }

  openPrivacy() {
    this.ngZone.run(() => this.router.navigate(['/about/privacy']))
  }

  deleteUser() {
    if (this.allFieldsAreFilled(this.password))
      this.authService.deleteUser(this.password)
  }

  showResetPassword: boolean = false
  login() {
    let myRef = this
    if (this.allFieldsAreFilled(this.mail, this.password)) {
      setTimeout(function () {
        myRef.showResetPassword = true
      }, 2000);
      this.authService.login(this.mail.trim().toLowerCase(), this.password)
    }

  }

  openView(view: string) {
    this.currentView = view
  }

  allFieldsAreFilled(...fields: string[]): boolean {
    let hasEmptyFields: boolean = this.util.hasEmptyFields(fields)
    if (hasEmptyFields)
      this.util.presentToast("Bitte fülle alle Felder aus.", 3000, "toast-warning")

    return !hasEmptyFields
  }

  back() {
    if (this.currentView === this.RESET_VIEW)
      this.openView(this.LOGIN_VIEW)
    else if(this.db.loggedUserUID){
      this.ngZone.run(() => this.router.navigate(['/owner-home']))      
    }else{
      this.ngZone.run(() => this.router.navigate(['/customer-home']))      
    }
  }

}
